const DateInputMask = {
  en: "YYYY-MM-DD",
  "zh-CN": "YYYY-MM-DD"
};
export {
  DateInputMask
};
//# sourceMappingURL=DatePicker.config.js.map
